export default "__VITE_ASSET__DYoXZYHW__"